import {
    FETCH_JOURNEYS_SUCCESS,

    FETCH_SPECIFIC_JOURNEY_START,
    FETCH_SPECIFIC_JOURNEY_SUCCESS,
    FETCH_SPECIFIC_JOURNEY_FAILED,

    FETCH_IN_PROGRESS_JOURNEYS_START,
    FETCH_IN_PROGRESS_JOURNEYS_SUCCESS,
    FETCH_IN_PROGRESS_JOURNEYS_FAILED,

    FETCH_COMPLETED_JOURNEYS_START,
    FETCH_COMPLETED_JOURNEYS_SUCCESS,
    FETCH_COMPLETED_JOURNEYS_FAILED,

    FETCH_JOURNEY_USER_PROGRESS_START,
    FETCH_JOURNEY_USER_PROGRESS_SUCCESS,
    FETCH_JOURNEY_USER_PROGRESS_FAILED,
    PATCH_USER_PROGRESS,
} from "../actions/JourneyTypes";
import {LOGIN_USER_SUCCESS} from "../actions/types";

const INITIAL_STATE = {
    isFetching: false,

    allJourneys: [],

    fetchingInProgressJourneys: false,
    fetchingCompletedJourneys: false,
    userInProgressJourneys: [],
    userCompletedJourneys: [],

    fetchingCurrentJourneyUserProgress: false,
    fetchingCurrentJourney: false,
    currentJourney: null,
    currentUserProgress: null,

    lastOpenJourney: null,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case LOGIN_USER_SUCCESS:
            return { ...state, lastOpenJourney: action.payload.journeyData.lastInProgressWatched }

        case FETCH_JOURNEYS_SUCCESS:
            return {
                ...state,
                allJourneys: action.payload,
            }

        case FETCH_IN_PROGRESS_JOURNEYS_START:
            return {
                ...state,
                fetchingInProgressJourneys: true
            }

        case FETCH_IN_PROGRESS_JOURNEYS_SUCCESS:
            return {
                ...state,
                userInProgressJourneys: action.payload,
                fetchingInProgressJourneys: false
            }

        case FETCH_IN_PROGRESS_JOURNEYS_FAILED:
            return {
                ...state,
                fetchingInProgressJourneys: false
            }

        case FETCH_COMPLETED_JOURNEYS_START:
            return {
                ...state,
                fetchingCompletedJourneys: true
            }

        case FETCH_COMPLETED_JOURNEYS_SUCCESS:
            return {
                ...state,
                userCompletedJourneys: action.payload,
                fetchingCompletedJourneys: false,
            }

        case FETCH_COMPLETED_JOURNEYS_FAILED:
            return {
                ...state,
                fetchingCompletedJourneys: false,
            }

        case FETCH_SPECIFIC_JOURNEY_START:
            return {
                ...state,
                fetchingCurrentJourney: true,
                currentJourney: null
            }

        case FETCH_SPECIFIC_JOURNEY_SUCCESS:
            return {
                ...state,
                fetchingCurrentJourney: false,
                currentJourney: action.payload,
            }

        case FETCH_SPECIFIC_JOURNEY_FAILED:
            return {
                ...state,
                fetchingCurrentJourney: false,
            }

        case FETCH_JOURNEY_USER_PROGRESS_START:
            return {
                ...state,
                fetchingCurrentJourneyUserProgress: true,
                currentJourney: null,
                currentUserProgress: null,
            }

        case FETCH_JOURNEY_USER_PROGRESS_SUCCESS:
            return {
                ...state,
                fetchingCurrentJourneyUserProgress: false,
                currentJourney: action.payload.journey,
                currentUserProgress: action.payload.userProgress
            }

        case FETCH_JOURNEY_USER_PROGRESS_FAILED:
            return {
                ...state,
                fetchingCurrentJourneyUserProgress: false,
            }

        case PATCH_USER_PROGRESS:

            //Indicate if we have completed or not the journey item
            let currentJourney = state.currentJourney;
            let items = Array.from(currentJourney.items);
            for (let item of items) {
                const isCompleted = action.payload.progress.includes(item.id);
                item.isCompleted = isCompleted;
            }

            return {
                ...state,
                currentUserProgress: action.payload,
                currentJourney: currentJourney,
            }

        default:
            return state;

    }
}
